import CustomButton from './CustomButton';
import { FaApple } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa";
import googleStore from '../assets/images/img-google-play.png';
import appStore from '../assets/images/img-app-store.png'

const FindAppFooter = () => {

    return (
        <>
            <div>
                <div style={{ backgroundColor: "#4682b4", padding: "50px 0", color: "#fff" }}>
                    <div className="container text-center p-2 p-sm-0">
                        <h2 className="fw-bold">Get the App</h2>
                        <p className="mt-3">
                            Download our app! Join over <strong>500,000</strong> people already using Our App.
                        </p>
                        <div className="d-flex justify-content-center mt-4">
                            <div className=' me-3'>
                                < img src={googleStore} alt='google-store' style={{ cursor: 'pointer', width: '150px', height: '44px' }} />
                            </div>
                            <div className=' me-3 app-store'>
                                < img src={appStore} alt='app-store' style={{ cursor: 'pointer', width: '150px', height: '44px' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default FindAppFooter;